import { Injectable } from '@angular/core';
import * as keythereum from 'keythereum';
import { KeyObjModel } from '@app/models/keyObj.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';


@Injectable()
export class WalletService {

  /**
   * Creates new wallet object with given password.
   * @param {string} password
   * @returns {Observable<KeyObjModel>}
   */
  createWallet(password: string): Observable<KeyObjModel> {
    return Observable.fromPromise(new Promise((resolve, reject) => {
      try {
        const params: any = {
          keyBytes: 32,
          ivBytes: 16
        };
        keythereum.create(params, (dk: any) => {
          const options: any = {
            kdf: 'pbkdf2',
            cipher: 'aes-128-ctr',
            kdfparams: {
              c: 65536,
              dklen: 32,
              prf: 'hmac-sha256'
            }
          };
          keythereum.dump(password, dk.privateKey, dk.salt, dk.iv, options, (keyObject: KeyObjModel) => {
            return resolve(keyObject);
          });
        });
      } catch (e) {
        return reject(e);
      }
    }));
  }

  /**
   * @param {KeyObjModel} keyObj
   * @param {string} password
   * @returns {Observable<Buffer>}
   */
  decryptKey(keyObj: KeyObjModel, password: string): Observable<any> {
    return Observable.fromPromise(new Promise(((resolve, reject) => {
      try {
        keythereum.recover(password, keyObj, (pKey: any) => {
          if (pKey !== null && !pKey.error) {
            pKey = pKey.toString('hex');
            // pKey = new Buffer(pKey, 'hex');
            return resolve(pKey);
          } else {
            return reject(new Error('error decrypting wallet.'));
          }
        });
      } catch (e) {
        return reject(e);
      }
    })));
  }

  /**
   * @param {KeyObjModel} keyObj
   * @param {string} currentPassword
   * @param {string} password
   * @returns {Observable<KeyObjModel>}
   */
  changePassword(keyObj: KeyObjModel, currentPassword: string, password: string): Observable<KeyObjModel> {
    return Observable.fromPromise(new Promise(((resolve, reject) => {
      this.decryptKey(keyObj, currentPassword).toPromise().then(data => {
        try {
          const params: any = {
            keyBytes: 32,
            ivBytes: 16
          };

          const options = {
            kdf: 'pbkdf2',
            cipher: 'aes-128-ctr',
            kdfparams: {
              c: 65536,
              dklen: 32,
              prf: 'hmac-sha256'
            }
          };
          const dk = keythereum.create(params);
          dk.privateKey = data;

          keythereum.dump(password, dk.privateKey, dk.salt, dk.iv, options, (newKeyObject: KeyObjModel) => {
            return resolve(newKeyObject);
          });
        } catch (e) {
          return reject(e);
        }
      }).catch(e => {
        return reject(e);
      });
    })));
  }

  /**
   * @param {KeyObjModel} keyObj
   * @param {string} privateKey
   * @param {string} password
   * @returns {Observable<KeyObjModel>}
   */
  changePasswordUsingKey(keyObj: KeyObjModel, privateKey: string, password: string): Observable<KeyObjModel> {
    return Observable.fromPromise(new Promise(((resolve, reject) => {
      try {
        const params: any = {
          keyBytes: 32,
          ivBytes: 16
        };

        const options = {
          kdf: 'pbkdf2',
          cipher: 'aes-128-ctr',
          kdfparams: {
            c: 65536,
            dklen: 32,
            prf: 'hmac-sha256'
          }
        };
        const dk = keythereum.create(params);
        dk.privateKey = privateKey;

        keythereum.dump(password, dk.privateKey, dk.salt, dk.iv, options, (newKeyObject: KeyObjModel) => {
          return resolve(newKeyObject);
        });
      } catch (e) {
        return reject(e);
      }
    })));
  }

  /**
   * Validates ETH address.
   * @param {string} address
   * @returns {boolean}
   */
  isAddressValid(address: string): boolean {
    const re = /^[0-9A-Fa-f]*$/g;
    if (!address || typeof address !== 'string' || address.replace('0x', '').length !== 40) {
      return false;
    }
    return re.test(address.replace('0x', ''));
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/wallet.service.ts